import { Box, Typography } from "@mui/material";

const SectionHeader = ({
    title,
    subtitle,
    action,
    actions,
    noWrap = false,
}) => {
    const resolvedActions = actions || action;

    return (
        <Box
            sx={(theme) => ({
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "space-between",
                alignItems: { xs: "flex-start", md: "center" },
                gap: { xs: theme.spacing(1.25), md: theme.spacing(1.5) },
                mb: 0,
            })}
        >
            <Box>
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 800,
                        lineHeight: 1.15,
                        letterSpacing: "-0.03em",
                        whiteSpace: noWrap ? "nowrap" : "normal",
                        fontSize: { xs: "1.35rem", md: "1.65rem" },
                    }}
                >
                    {title}
                </Typography>

                {subtitle && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            mt: 0.45,
                            maxWidth: 760,
                            lineHeight: 1.55,
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>

            {resolvedActions && (
                <Box
                    sx={(theme) => ({
                        display: "flex",
                        gap: theme.spacing(1),
                        flexDirection: { xs: "column", sm: "row" },
                        width: { xs: "100%", sm: "auto" },
                        alignSelf: { xs: "stretch", md: "center" },

                        "& > *": {
                            width: { xs: "100%", sm: "auto" },
                        },
                    })}
                >
                    {resolvedActions}
                </Box>
            )}
        </Box>
    );
};

export default SectionHeader;
